<template>
  <div class="homePage">
    <!--<topfixed></topfixed>-->
    <div class="swiper-container">
      <div class="swiper-wrapper">
        <div class="swiper-slide one-screen-bg">
          <div class="content-wrap">
            <div class="c-inner-title">
              <h2 class="c-inner-title-t">研发与建设</h2>
              <h3 class="c-inner-title-c">Research and Development &amp; Construction</h3>
              <p class="c-inner-title-line"></p>
            </div>
            <div class="c-inner-describe">
              <p>依托于IT系统、大数据及软硬件，服务旅游行业主管单位、旅游景区、旅游住宿单位、旅行社的各种公共服务、公共管理、营销推广等智慧化需求。</p>
            </div>
            <div class="wrap-nav-second clearfix">
              <router-link to="/listMsg" class="lf every-tit" :primary="10" @click.native="getlist($event)">
                  <span class="icon-local_atm icon" :primary="10"></span>
                  <p class="firstp" :primary="10">区域智慧营销</p>
              </router-link>
              <router-link to="/listMsg" class="lf every-tit" :primary="11" @click.native="getlist($event)">
                  <span class="icon-organization icon" :primary="11"></span>
                  <p class="firstp" :primary="11">智慧旅游公共服务</p>
              </router-link>
              <router-link to="/listMsg" class="lf every-tit" :primary="12" @click.native="getlist($event)">
                  <span class="icon-cog icon" :primary="12"></span>
                  <p class="firstp" :primary="12">景区智慧管理</p>
              </router-link>
            </div>
            <div class="c-inner-more">
              <router-link to="/yfyjsMore">
                <span>more</span>
                <p></p>
              </router-link>
            </div>
          </div>
        </div>
        <div class="swiper-slide two-screen-bg">
          <div class="content-wrap">
            <div class="c-inner-title">
              <h2 class="c-inner-title-t">规划与顾问</h2>
              <h3 class="c-inner-title-c">PLANNING &amp; CONSULTING</h3>
              <p class="c-inner-title-line"></p>
            </div>
            <div class="c-inner-describe">
              <p>为各级旅游主管单位和目的地管理者提供智慧旅游的规划、设计、顾问和监理服务，帮助目的地经营管理者从大数据视角和“互联网+“视角对目的地进行智慧化管理和运营、营销推广。
              </p>
            </div>
            <div class="wrap-nav-second clearfix">
              <router-link to="/listMsg" class="lf every-tit" :primary="5" @click.native="getlist($event)">
                  <span :primary="5" class="icon-feather icon"></span>
                  <p :primary="5" class="firstp">智慧旅游规划</p>
              </router-link>
              <router-link to="/listMsg" :primary="6" class="lf every-tit" @click.native="getlist($event)">
                  <span :primary="6" class="icon-pencil icon"></span>
                  <p :primary="6" class="firstp">智慧旅游设计</p>
              </router-link>
              <router-link :primary="7" to="/listMsg" class="lf every-tit" @click.native="getlist($event)">
                  <span :primary="7" class="icon-user-tie icon"></span>
                  <p :primary="7" class="firstp">顾问和监理</p>
              </router-link>
            </div>
            <div class="c-inner-more">
              <router-link to="/ghygwMore">
                <span>more</span>
                <p></p>
              </router-link>
            </div>
          </div>
        </div>
        <div class="swiper-slide three-screen-bg">
          <div class="content-wrap">
            <div class="c-inner-title">
              <h2 class="c-inner-title-t">投资与运营</h2>
              <h3 class="c-inner-title-c">NVESTMENT &amp; OPERATION</h3>
              <p class="c-inner-title-line"></p>
            </div>
            <div class="c-inner-describe">
              <p>基于大数据和政策环境，按需构建可视化投资效益分析模型，提出切实符合市场需求、贴合项目发展定位、投资效益显著的方案，并探索PPP及O2O平台模式下的智慧旅游整体投资模式，创新构建“互联网+旅游”项目投资与运营新方式。
                 +“视角对目的地进行智慧化管理和运营、营销推广。
              </p>
            </div>
            <div class="wrap-nav-second clearfix">
              <router-link to="/listMsg" :primary="16" class="lf every-tit" @click.native="getlist($event)">
                  <span class="icon-joomla icon" :primary="16"></span>
                  <p class="firstp" :primary="16">智慧旅游整体投资</p>
              </router-link>
              <router-link :primary="17" to="/listMsg" class="lf every-tit" @click.native="getlist($event)">
                  <span :primary="17" class="icon-brand icon"></span>
                  <p :primary="17" class="firstp">智慧旅游平台运营</p>
              </router-link>
              <router-link :primary="18" to="/listMsg" class="lf every-tit" @click.native="getlist($event)">
                  <span :primary="18" class="icon-location icon"></span>
                  <p :primary="18" class="firstp">旅游目的地运营</p>
              </router-link>
            </div>
            <div class="c-inner-more">
              <router-link to="/tzyyyMore">
                <span>more</span>
                <p></p>
              </router-link>
            </div>
          </div>
        </div>
        <div class="swiper-slide four-screen-bg">
          <div class="content-wrap">
            <div class="c-inner-title">
              <h2 class="c-inner-title-t">目的地营销</h2>
              <h3 class="c-inner-title-c">DESTINATION MARKETING</h3>
              <p class="c-inner-title-line"></p>
            </div>
            <div class="c-inner-describe">
              <p>
                从策划到实施，从营销顾问到新媒体及线上线下活动的执行，专注目的地营销推广，建立旅游目的地产品与目标市场间的关联系统，并有效提升所占市场份额。
              </p>
            </div>
            <div class="wrap-nav-second clearfix">
              <router-link to="/listMsg" :primary="20" class="lf every-tit" @click.native="getlist($event)">
                  <span :primary="20" class="icon-lightbulb icon"></span>
                  <p :primary="20" class="firstp">规划与顾问</p>
              </router-link>
              <router-link :primary="21" to="/listMsg" class="lf every-tit" @click.native="getlist($event)">
                  <span :primary="21" class="icon-key icon"></span>
                  <p :primary="21" class="firstp">新媒体营销</p>
              </router-link>
              <router-link :primary="22" to="/listMsg" class="lf every-tit" @click.native="getlist($event)">
                  <span :primary="22" class="icon-broadcast icon"></span>
                  <p :primary="22" class="firstp">广告与活动</p>
              </router-link>
            </div>
            <div class="c-inner-more">
              <router-link to="/mddyxMore">
                <span>more</span>
                <p></p>
              </router-link>
            </div>
          </div>
        </div>
      </div>
        <!-- Add Pagination -->
      <div class="swiper-pagination"></div>
    </div>
  </div>
</template>

<script>
import "../../assets/css/swiper.min.css"
import "../../assets/js/swiper.js"
//import topfixed from '../topfixed'
export default {
  name: "homePage",
  data() {
    return {
      msg: ""
    };
  },
  computed:{
    author () {
        //  通过this.$store能够访问到 store 并且获取到 state
      return this.$store.state.author
    }
  },
  components:{
//  topfixed:topfixed
  },
  mounted() {
    this.swiperfn();
  },
  methods: {
    swiperfn(){
      new Swiper(".swiper-container", {
        pagination: ".swiper-pagination",
        paginationClickable: true,
        autoplay:5000,
        speed: 600,
        loop: true
      });
    },
    getlist(ev){
       let number = ev.target.attributes.primary.nodeValue;
       this.$store.commit("getlist",{
         primary:number
       });
      // this.$store.dispatch('check',number)
    }
  }
};
</script>

<style scoped>
html,
body {
  position: relative;
  height: 100%;
}
.c-inner-more{ margin: 0 auto;margin-top: .44rem;width: .6rem}
.c-inner-more span{font-size: .24rem; color: #009fe7;}
.c-inner-more p{border-bottom: dashed 1px #009fe7}
.icon{padding-top: .16rem;display: inline-block;color: #fff}
.wrap-nav-second{margin-top: 1.54rem}
.every-tit p{font-size: .2rem;color: #fff;width: 83%;margin: 0 auto; line-height: .32rem}
/* .every-tit .firstp{padding-top: .16rem} */
.every-tit{width: 1.18rem;height: 1.38rem;margin-left: .35rem;-webkit-box-shadow: 0 0 6px rgba(255,255,255,.5); box-shadow: 0 0 6px rgba(255,255,255,.4);background: rgba(73,73,73,.15)}
.content-wrap{width: 78%;margin: 0 auto;}
.c-inner-title-line{border-bottom: solid 1px #2a9ee7;width: 100%;height: .01rem}
.one-screen-bg {
  background: url(../../assets/images/yanfa.jpg) no-repeat;
  background-size: cover;
  color: #fff;
}
.two-screen-bg {
  background: url(../../assets/images/guihua.jpg) no-repeat;
  background-size: cover;
  color: #fff;
}
.three-screen-bg {
  background: url(../../assets/images/touzi.jpg) no-repeat;
  background-size: cover;
  color: #fff;
}
.four-screen-bg {
  background: url(../../assets/images/mudidi.jpg) no-repeat;
  background-size: cover;
  color: #fff;
}
.c-inner-describe{color: #ccc;padding-top: .4rem; text-align: left;text-indent:.2rem;}
.c-inner-describe p{ line-height: .36rem;font-size: .24rem;}
.c-inner-title{text-align: center;font-weight: 400}
.c-inner-title-t{color: #fff;display: block;font-size: .4rem;padding-top: 1.5rem}
.c-inner-title-c{color: #2a9ee7;font-size: .2rem;padding-top: .16rem; }
.swiper-container-horizontal > .swiper-pagination-bullets,
.swiper-pagination-custom,
.swiper-pagination-fraction {
  bottom: 10%;
}
.swiper-container,
.homePage {
  width: 100%;
  height: 100%;
}
.swiper-slide {
  text-align: center;
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
}
@media screen and (min-width: 414px) {
  .every-tit p{width: 78%;}
}
</style>



// WEBPACK FOOTER //
// src/components/homePage/homePage.vue